module.exports = __webpack_public_path__ + "static/media/logo-inceres-branco.7e248aac.png";